import { OrderApi } from "../api/order.api";
import { AngularFirestore } from "@angular/fire/firestore";
import { HttpClient } from "@angular/common/http";

export class FirebaseApi {
  public order: OrderApi;

  constructor(public db: AngularFirestore, public httpClient: HttpClient) {
    this.order = new OrderApi(this.db);
  }
}
